export default [
  {
    name : 'Blank Template',
    description : 'Blank template for generic use.'
  },
  {
    name : 'Account Invitation/Registration',
    description : 'When users are invited to an application, they will receive this invitation email.',
    alias : 'activateAccount',
    email : {
      subject : 'Join Leverege',
      data : ( { moltenUi } ) => `<div style="font-family:Inter, sans-serif; max-width:600px; min-width:200px; color: #181e25; margin: 0 auto;">
      <div style="background-color:white; padding: 32px 32px 32px 32px; text-align: left;">
        <img width="auto" style="margin: 24px 0px;" src="https://storage.googleapis.com/leverege-branding-assets/logo-color.png">
        <hr class="solid" style="border: 1px solid #e7eaef">
        <div style="text-align:left; font-size:20px; line-height:28px; font-weight: bold; margin: 24px 0px;">
                Join Leverege
              </div>
              <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">
                {{#if inviter.email}}
                  {{#if inviter.name}}
                    {{inviter.name}} (<a href="mailto:{{inviter.email}}">{{inviter.email}}</a>) has invited you to join <b>Leverege</b>.
                  {{else}}
                    You have been invited by <a href="mailto:{{inviter.email}}">{{inviter.email}}</a> to join <b>Leverege</b>.
                  {{/if}}
                {{else}}
                  You have been invited to join <b>Leverege</b>.
                {{/if}}
              </div> 
              <div style="display:block; text-align:left; font-size:18px; margin: 24px 0px;">
                <span style="background:#194edc; color:white; padding:10px 20px; border-radius:5px; font-size: 13px;">
                  ${
  moltenUi ?
    `<a style="color:white;text-decoration:none;" href="{{#switch uiName}}
                        {{#case "local"}}https://0.0.0.0:8588/activateAccount?username={{username}}&email={{email}}&token={{activationToken}}{{#if projectId}}&projectId={{projectId}}{{/if}}{{/case}}
                        {{#default}}
                          {{#if projectId}}${moltenUi}/{{projectId}}/_config?imagineHost={{apiHost}}&noReplace=true&redirect=activateAccount%3Fusername={{username}}%26email={{email}}%26token={{activationToken}}%26projectId={{projectId}}
                          {{else}}https://0.0.0.0:8588/activateAccount?username={{username}}&email={{email}}&token={{activationToken}}{{/if}}
                        {{/default}}
                      {{/switch}}">
                        Join Now
                      </a>` :
    `<a style="color:white;text-decoration:none;" href="{{#switch uiName}}{{#case "local"}}https://0.0.0.0:8588{{/case}}{{#default}}{{apiHost}}/v1/view{{/default}}{{/switch}}/activateAccount?username={{username}}&email={{email}}&token={{activationToken}}{{#if projectId}}&projectId={{projectId}}{{/if}}">
                        Join Now
                      </a>`
}
                </span>
              </div>
          
              <div style="display:block; box-sizing:border-box; font-size:15px; line-height:24px; text-align:left; color:#394756">
                 Leverege is the Leading IoT Platform for low-cost, cross-vertical applications. Digital transformation is now a business imperative. Leverege makes it happen with affordable enterprise IoT solutions built for scale.
              </div>
            </div>
            <div style="background-color:#e7eaef; padding: 11px;">
              <div style="text-align:center; font-size:12px; line-height:18px;">
                Copyright Leverege, LLC. All Rights Reserved.
              </div> 
            </div>
          </div>`
    },
    sms : {
      data : ( { moltenUi } ) => (
        `You've been invited by {{inviter.name}} to use the Leverege Stack. Visit the following link to activate your account: 
        {{#switch uiName}}
          {{#default}}
            ${moltenUi}/{{projectId}}/_config?imagineHost={{apiHost}}&noReplace=true&redirect=activateAccount%3Fusername={{username}}%26email={{email}}%26token={{activationToken}}%26projectId={{projectId}}
          {{/default}}
        {{/switch}}`
      )
    }
  },
  {
    name : 'Password Reset Request',
    description : 'When users request to reset their password because they forgot the password at login',
    alias : 'resetPassword',
    email : {
      subject : 'Leverege Password Reset',
      data : `<div style="font-family:Inter, sans-serif; max-width:600px; min-width:200px; color: #181e25; margin: 0 auto;">
      <div style="background-color:white; padding: 32px 32px 32px 32px; text-align: left;">
        <img width="auto" style="margin: 24px 0px;" src="https://storage.googleapis.com/leverege-branding-assets/logo-color.png">
        <hr class="solid" style="border: 1px solid #e7eaef">
        <div style="text-align:left; font-size:20px; line-height:28px; font-weight: bold; margin: 24px 0px;">
                  Reset Your Password
                </div>
                <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">
                  We have received a password reset request for your Leverege account. Please click the link below to reset your password.
                </div> 
                <div style="display:block; text-align:left; font-size:18px; margin: 24px 0px;">
                  <span style="background:#194edc; color:white; padding:10px 20px; border-radius:5px; font-size: 13px;">
                    <a style="color:white;text-decoration:none;" href="{{#switch uiName}}{{#case "local"}}https://0.0.0.0:8588{{/case}}{{#default}}{{apiHost}}/v1/view{{/default}}{{/switch}}/resetPassword?username={{username}}{{#if projectId}}&projectId={{projectId}}{{/if}}&token={{resetToken}}">
                      Reset Your Password
                    </a>
                  </span>
                </div>
            
                <div style="display:block; box-sizing:border-box; font-size:15px; line-height:24px; text-align:left; color:#394756">
                   If you did not make this request you can ignore this message. This link will remain active for 24 hours.
                </div>
              </div>
              <div style="background-color:#e7eaef; padding: 11px;">
                <div style="text-align:center; font-size:12px; line-height:18px;">
                  Copyright © Leverege, LLC. All Rights Reserved.
                </div> 
              </div>
            </div>`
    },
    sms : {
      data : ( { moltenUi } ) => (
        `We have received a password reset request for your Leverege account. Please click the following link below to reset your password: 
        {{#switch uiName}}
          {{#default}}
          https://molten-ui.web.app/{{projectId}}/_config?imagineHost={{apiHost}}&noReplace=true&redirect=resetPassword%3Fusername={{username}}%26email={{email}}%26token={{activationToken}}%26projectId={{projectId}}
          {{/default}}
        {{/switch}}`
      )
    }
  },
  {
    name : 'Password Reset Successful',
    description : 'When users successfully reset their password, they receive a confirmation email',
    alias : 'resetPasswordSuccess',
    email : {
      subject : 'Reset Password Successful',
      data : `<div style="font-family:Inter, sans-serif; max-width:600px; min-width:200px; color: #181e25; margin: 0 auto;">
      <div style="background-color:white; padding: 32px 32px 32px 32px; text-align: left;">
        <img width="auto
        " style="margin: 24px 0px;" src="https://storage.googleapis.com/leverege-branding-assets/logo-color.png">
        <hr class="solid" style="border: 1px solid #e7eaef">
        <div style="text-align:left; font-size:20px; line-height:28px; font-weight: bold; margin: 24px 0px;">
                Password Reset Successful
              </div>
              <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">
                Your Leverege password has been changed for username {{username}}. 
              </div> 
              <div style="display:block; box-sizing:border-box; font-size:15px; line-height:24px; text-align:left; color:#394756">
                 If you did not do this, please contact your system administrator.
              </div>
            </div>
            <div style="background-color:#e7eaef; padding: 11px;">
              <div style="text-align:center; font-size:12px; line-height:18px;">
              Copyright © Leverege, LLC. All Rights Reserved.
              </div> 
            </div>
          </div>`
    }
  },
  {
    name : 'Two-Step Enabled',
    description : 'User has enabled two-step authentication',
    alias : 'twoFactorEnabled',
    email : {
      subject : 'You turned on two-step authentication',
      data : `<div style="font-family:Inter, sans-serif; max-width:600px; min-width:200px; color: #181e25; margin: 0 auto;">
      <div style="background-color:white; padding: 32px 32px 32px 32px; text-align: left;">
        <img width="auto" style="margin: 24px 0px;" src="https://storage.googleapis.com/leverege-branding-assets/logo-color.png">
        <hr class="solid" style="border: 1px solid #e7eaef">
        <div style="text-align:left; font-size:20px; line-height:28px; font-weight: bold; margin: 24px 0px;">
              Two-Step Authentication Turned On
            </div>
            <hr class="solid" style="border: 1px solid #e7eaef">
            <div style="padding: 10px 0px;">
                <img src="https://storage.googleapis.com/molten-ui-assets/two-step-lock.png" height="100" width="100" />
            </div>
            <div>
                <span>Hi {{#if name}}{{name}}{{else}}there{{/if}},</span>
            </div>
            <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px; font-weight: bold;">
                Two-step authentication has been turned on for your Leverege account.
            </div>
            <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">
                <ul>
                    <li>
                        You'll need to provide a security code and a password when you sign in to your account.
                    </li>
                    <li>
                        Remember that your backup codes can also be used in case you lose your device.
                    </li>
                </ul>
            </div>
            <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">
                If you'd like to turn off two-step authentication, log in to the application to access your account settings.
            </div>
            <div style="text-align:left; font-size:16px;">
                Thanks!
            </div>
            <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">
                The Leverege Team
            </div>
          </div>
          <div style="background-color:#e7eaef; padding: 11px;">
            <div style="text-align:center; font-size:12px; line-height:18px;">
              Copyright Leverege. All Rights Reserved.
            </div> 
          </div>
        </div>`
    }
  },
  {
    name : 'Two-Step Disabled',
    description : 'User has disabled two-step authentication',
    alias : 'twoFactorDisabled',
    email : {
      subject : 'You turned off two-step authentication',
      data : `<div style="font-family:Inter, sans-serif; max-width:600px; min-width:200px; color: #181e25; margin: 0 auto;">
      <div style="background-color:white; padding: 32px 32px 32px 32px; text-align: left;">
        <img width="auto" style="margin: 24px 0px;" src="https://storage.googleapis.com/leverege-branding-assets/logo-color.png">
        <hr class="solid" style="border: 1px solid #e7eaef">
        <div style="text-align:left; font-size:20px; line-height:28px; font-weight: bold; margin: 24px 0px;">
              Two-Step Authentication Turned Off
            </div>
            <hr class="solid" style="border: 1px solid #e7eaef">
            <div style="padding: 10px 0px;">
                <img src="https://storage.googleapis.com/molten-ui-assets/two-step-lock.png" height="100" width="100" />
            </div>
            <div>
                <span>Hi {{#if name}}{{name}}{{else}}there{{/if}},</span>
            </div>
            <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">
                <span style="font-weight: bold;">Two-step authentication has been turned off for your account.</span> You'll no longer need to provide a security code to sign in.
            </div>
            <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">
                If you'd like to turn on two-step authentication, log in to the application to access your account settings.
            </div>
            <div style="text-align:left; font-size:16px;">
                Thanks!
            </div>
            <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">
                The Leverege Team
            </div>
          </div>
          <div style="background-color:#e7eaef; padding: 11px;">
            <div style="text-align:center; font-size:12px; line-height:18px;">
              Copyright Leverege. All Rights Reserved.
            </div> 
          </div>
        </div>`
    }
  },
  {
    name : 'Two-Step Code',
    description : 'When a user attempts to log in, they will receive a code via email or SMS',
    alias : 'twoFactorCode',
    email : {
      subject : 'Your Two-Step Verification Code',
      data : '<div style="font-family:Inter, sans-serif; max-width:600px; min-width:200px; background-color: #181e25; margin: 0 auto;">  <div style="background-color:white; padding: 32px 32px 32px 32px; text-align: left;">  <img width="140" height="30" style="margin: 24px 0px;" src="https://molten-ui-assets.storage.googleapis.com/leverege-logo.png">  <hr class="solid" style="border: 1px solid #e7eaef">  <div style="text-align:left; font-size:20px; line-height:28px; font-weight: bold; margin: 24px 0px;">  Sign In  </div>  <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">  Your two-step verification code is below. Enter the code in your open browser window and we\'ll help you get signed in. This code expires in 5 minutes.  </div>  <div style="font-weight: bold; overflow:auto; background-color: #f0f6ff; padding: 15px; border-radius: 5px; text-align: center;">  <span style="color:black; padding:10px 20px; border-radius:5px; font-size: 24px;">  {{code}}  </span>  </div>  <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">  If you didn\'t request this email, there\'s nothing to worry about - you can safely ignore it.  </div>  </div>  <div style="background-color:#e7eaef; padding: 11px;">  <div style="text-align:center; font-size:12px; line-height:18px;">  Copyright Leverege, LLC. All Rights Reserved.  </div>   </div> </div>'
    },
    sms : {
      data : '{{code}} is your security code for Leverege. If you did not request this code, you can safely ignore this message.'
    }
  },
  {
    name : 'One-Time Access Code Request Error',
    description : 'When a user attempts to use the one-time access code feature, but has two-step authentication enabled for that method (ie email), they will receive an error notification',
    alias : 'loginCodeError',
    email : {
      subject : 'One-Time Access Code Request Error',
      data : '<div style="font-family:Inter, sans-serif; max-width:600px; min-width:200px; background-color: #181e25; margin: 0 auto;">  <div style="background-color:white; padding: 32px 32px 32px 32px; text-align: left;">  <img width="140" height="30" style="margin: 24px 0px;" src="https://molten-ui-assets.storage.googleapis.com/leverege-logo.png">  <hr class="solid" style="border: 1px solid #e7eaef">  <div style="text-align:left; font-size:20px; line-height:28px; font-weight: bold; margin: 24px 0px;">  Error: Access Code Not Available  </div>  <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">  You have enabled two-step verification with this email. One-Time access codes are not available using the same method as two-step verification.   <br><br>Please choose another one-time access code method or sign with your credentials.  </div>  </div>  <div style="background-color:#e7eaef; padding: 11px;">  <div style="text-align:center; font-size:12px; line-height:18px;">  Copyright Leverege, LLC. All Rights Reserved.  </div>   </div> </div>'
    },
    sms : {
      data : 'You have enabled two-step verification with this phone number. One-Time access codes are not available using the same method as two-step verification. Please choose another one-time access code method or sign with your credentials.'
    }
  },
  {
    name : 'One-Time Access Code',
    description : 'When a user requests an access code, they will receive this email/SMS template',
    alias : 'loginCode',
    email : {
      subject : 'One-Time Access Code',
      data : `<div style="font-family:Inter, sans-serif; max-width:600px; min-width:200px; color: #181e25; margin: 0 auto;">
      <div style="background-color:white; padding: 32px 32px 32px 32px; text-align: left;">
        <img width="auto" style="margin: 24px 0px;" src="https://storage.googleapis.com/leverege-branding-assets/logo-color.png">
        <hr class="solid" style="border: 1px solid #e7eaef">
        <div style="text-align:left; font-size:20px; line-height:28px; font-weight: bold; margin: 24px 0px;">
          Sign In
        </div>
        <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">
            Your one-time sign in code is below. Enter the code into the form and we'll help you get signed in. This code only works once and expires in 5 minutes.
        </div>
        <div style="font-weight: bold; overflow:auto; background-color: #f0f6ff; padding: 15px; border-radius: 5px; text-align: center;">
          <span style="color:black; padding:10px 20px; border-radius:5px; font-size: 24px;">
            {{code}}
          </span>
        </div>
      </div>
      <div style="background-color:#e7eaef; padding: 11px;">
        <div style="text-align:center; font-size:12px; line-height:18px;">
          Copyright Leverege, LLC. All Rights Reserved.
        </div> 
      </div>
    </div>`
    },
    sms : {
      data : '{{code}} is your one time sign in code for Leverege. If you did not request this code, you can safely ignore this message.'
    }
  },
  {
    name : 'Profile Changed',
    description : 'When users change any of their profile information, they will receive this email',
    alias : 'profileChanged',
    email : {
      subject : 'Profile Changed',
      data : `<div style="font-family:Inter, sans-serif; max-width:600px; min-width:200px; color: #181e25; margin: 0 auto;">
      <div style="background-color:white; padding: 32px 32px 32px 32px; text-align: left;">
        <img width="120" style="margin: 24px 0px;" src="https://storage.googleapis.com/leverege-branding-assets/logo-color.png">
        <hr class="solid" style="border: 1px solid #e7eaef">
        <div style="text-align:left; font-size:20px; line-height:28px; font-weight: bold; margin: 24px 0px;">
          Your Leverege User Profile Was Updated
        </div>
        <hr class="solid" style="border: 1px solid #e7eaef">
        <div style="text-align:left; font-size:16px; line-height:26px; margin: 24px 0px;">
          Hi {{#if name}}{{name}}{{else}}there{{/if}},
        </div> 
            <div style="display:block; box-sizing:border-box; font-size:15px; line-height:24px; text-align:left; color:#394756; margin-bottom: 20px;">
              Your user profile was succesfully updated on {{formatDate time }}.
            </div>
            <div style="display:block; box-sizing:border-box; font-size:15px; line-height:24px; text-align:left; color:#394756; margin-bottom: 20px;">
              Change Summary:
            </div>
            <div style="display:block; box-sizing:border-box; font-size:15px; line-height:24px; text-align:left; color:#394756; margin-bottom: 20px;">
              <table style="text-align: left; border-spacing: 0;">
                <thead style="background-color: #e7eaef;">
                    <tr>
                      <th style="padding: 5px;">Field</th>
                      <th style="padding: 5px;">Old Value</th>
                      <th style="padding: 5px;">New Value</th>
                    </tr>
                </thead>
                <tbody>
                  {{#each changedFields}}
                    {{#if (startsWith this.path 'metadata')}}
                      {{#switch this.path}}
                        {{#case "metadata"}}
                          <tr>
                            <td class="cell">User Preferences</td>
                            <td class="cell">{{jsonStringify this.oldValue}}</td>
                            <td class="cell">{{jsonStringify this.newValue}}</td>
                          </tr>
                        {{/case}}
                        {{#default}}
                          <tr>
                            <td class="cell">{{camelCaseToTitleCase (replaceAll this.path 'metadata/' '')}}</td>
                            <td class="cell">{{this.oldValue}}</td>
                            <td class="cell">{{this.newValue}}</td>
                          </tr>
                        {{/default}}
                      {{/switch}}
                    {{else}}
                      <tr>
                        <td class="cell">{{capitalize this.path}}</td>
                        <td class="cell">{{#if this.oldValue}}{{this.oldValue}}{{else}}*******{{/if}}</td>
                        <td class="cell">{{#if this.newValue}}{{this.newValue}}{{else}}*******{{/if}}</td>
                      </tr>
                    {{/if}}
                  {{/each}}
                </tbody>
            </table>
            </div>
            <div style="display:block; box-sizing:border-box; font-size:15px; line-height:24px; text-align:left; color:#394756; margin-bottom: 20px;">
              If you did not make this request, please contact your project adminstrator.
            </div>
            <div style="display:block; box-sizing:border-box; font-size:15px; line-height:24px; text-align:left; color:#394756">
              Thanks!
            </div>
            <div style="display:block; box-sizing:border-box; font-size:15px; line-height:24px; text-align:left; color:#394756">
              The Leverege Team
            </div>
      </div>
            <div style="background-color:#e7eaef; padding: 11px;">
              <div style="text-align:center; font-size:12px; line-height:18px;">
              Copyright Leverege, LLC. All Rights Reserved.
              </div> 
            </div>
          </div>`
    },
  },
]
